import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/About.css";
// import FAQSection from '../components/sections/FAQSection';

const About = () => {
  const [, setHeroImageLoaded] = useState(false);

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    elements.forEach((el) => observer.observe(el));

    // Preload the high-res image
    const img = new Image();
    img.src = `${process.env.PUBLIC_URL}/images/about_high.jpg`;
    img.onload = () => setHeroImageLoaded(true);
  }, []);

  return (
    <div className="about-page">
      {/* Floating blobs + heartbeat */}
      <div className="bg-blob blob1"></div>
      <div className="bg-blob blob2"></div>
      <div className="bg-blob blob3"></div>
      <div className="heartbeat"></div>
      
      {/* Hero Section */}
      <section className="hero reveal">
        {/* Background image with lazy loading */}
        <div className="hero-background">
          <img 
            src={`${process.env.PUBLIC_URL}/images/about.png`}
            srcSet={`${process.env.PUBLIC_URL}/images/about_high.jpg 2x`}
            alt="Caregiver with patient"
            className="hero-bg-image"
            loading="lazy"
          />
          <div className="hero-overlay"></div>
        </div>
        
        <div className="hero-content">
          <h1>
            Compassionate Home Care You Can Trust
          </h1>
          <p>
            Bringing quality medical care and support to your doorstep in Coimbatore.
          </p>
          {/* <blockquote >
            "To care for those who once cared for us is one of the highest honors."
          </blockquote> */}
          <Link to="/contact">
            <button className="cta-btn">Contact Us</button>
          </Link>
        </div>
      </section>
      
      {/* About Section */}
      <section className="about-section reveal">
        <div className="about-content">
          {/* Left Text Block */}
          <div className="about-text">
            <h2 className="gradient-heading">About Timeless Home Care Service</h2>
            <p className="intro-text">
              At <span className="highlight">Timeless Home Care</span>, we bring 
              professional <strong>medical care</strong> and <strong>personal support</strong> 
              directly to your home in Coimbatore, ensuring comfort and dignity for your loved ones.
            </p>
            <div className="features-grid">
              <div className="feature-card">
                <span className="icon">🏥</span>
                <h4>Skilled Nursing Care</h4>
                <p>Experienced nurses providing clinical expertise at home.</p>
              </div>
              <div className="feature-card">
                <span className="icon">💊</span>
                <h4>Medication Management</h4>
                <p>Safe, timely, and accurate support for prescriptions.</p>
              </div>
              {/* <div className="feature-card">
                <span className="icon">🤝</span>
                <h4>Personalized Support</h4>
                <p>Care plans tailored to your loved one's unique needs.</p>
              </div> */}
              <div className="feature-card">
                <span className="icon">❤️</span>
                <h4>Companionship</h4>
                <p>Friendly, compassionate presence to ease daily life.</p>
              </div>
            </div>
            <blockquote className="standard-quote">
              "Healing begins where love and care are felt."
            </blockquote>
          </div>
          </div>
          {/* Right Image */}
          {/* <div className="about-image">
            <img 
              src={`${process.env.PUBLIC_URL}/images/about.png`} 
              alt="Caregiver with patient" 
              loading="lazy"
            />
          </div> */}
        
      </section>
      
      {/* Mission Section */}
      <div className="heartbeat"></div>
      <section className="mission-section reveal">
        <h2 className="mission-title">🌟 Our Mission & Approach</h2>
        <p className="mission-subtext">
          Our mission is to provide the <span className="highlight">highest quality home care</span> 
          with a <span className="highlight">personalized</span> and 
          <span className="highlight"> trustworthy approach</span>, creating comfort 
          and companionship at home.
        </p>
        <div className="mission-cards">
          <div className="card fade-in">
            <span className="icon">💙</span>
            <h3>Personalized Care</h3>
            <p>Tailored support designed around your lifestyle and needs.</p>
          </div>
          <div className="card fade-in" style={{ animationDelay: "0.2s" }}>
            <span className="icon">🤝</span>
            <h3>Trust & Compassion</h3>
            <p>Building lasting relationships through kindness and empathy.</p>
          </div>
          <div className="card fade-in" style={{ animationDelay: "0.4s" }}>
            <span className="icon">🌿</span>
            <h3>Promoting Independence</h3>
            <p>Encouraging confidence and self-reliance every step of the way.</p>
          </div>
        </div>
        <blockquote className="standard-quote">
          <span className="quote-mark">❝</span>
          The best way to find yourself is to lose yourself in the service of others.
          <span className="quote-mark">❞</span>
          <br />
          <cite>– Gandhi</cite>
        </blockquote>
      </section>
      
      {/* Why Choose Us Section */}
      <section className="choose-section reveal">
        <h2>Why Families Trust Timeless Home Care</h2>
        <div className="choose-grid">
          <div className="choose-card">👩‍⚕️ Licensed & Experienced Nurses</div>
          <div className="choose-card">🕒 24/7 Availability</div>
          <div className="choose-card">⭐ 4.9 Google Rating</div>
          <div className="choose-card">📋 Personalized Care Plans</div>
        </div>
        <blockquote className="standard-quote">
          "When you are surrounded by care, healing feels closer."
        </blockquote>
      </section>
       {/* CTA Banner */}
      <section className="cta-banner reveal">
        <h2>Need compassionate care for your loved ones? We're here 24/7.</h2>
        <Link to="/contact">
          <button className="cta-btn">Schedule a Consultation</button>
        </Link>
      </section>
      {/* Testimonials Section */}
      <section className="testimonials reveal">
        <h2>What Families Say About Us</h2>
        {/* <blockquote className="standard-quote">
          "The greatest gift you can give is your presence and care."
        </blockquote> */}
        <div className="testimonial-list">
          <div className="testimonial">
            <p>
              "Very professional and caring staff. They helped my father recover
              at home with ease."
            </p>
            <span>- Client Review</span>
          </div>
          <div className="testimonial">
            <p>
              "Excellent service! Nurses are kind, punctual, and highly skilled."
            </p>
            <span>- Client Review</span>
          </div>
        </div>
      </section>
      
      {/* Contact Section */}
      {/* <section className="contact-section reveal">
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>
            📍 220/1c Indranagar Narasimhanaickenpalayam, Coimbatore, Tamil Nadu
            641031
          </p>
          <p>📞 +91 82700 07174</p>
          <p>⏰ Open 24/7</p>
          <blockquote className="standard-quote">
            "Care is the language of love, spoken through actions."
          </blockquote>
        </div>
        <div className="contact-map">
          <iframe
            title="map"
            src="https://maps.google.com/maps?q=Coimbatore&t=&z=13&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section> */}
      
     
      
      {/* <FAQSection /> */}
    </div>
  );
};

export default About;